<template>

  <header>
    <nav class="nav-main-box h80">
      <div class="container">
        <div class="company-logo">
          <img src="./../../../assets/img/logo-new.jpg" alt style="margin-right: 80px;" />
          <el-menu :default-active="activeIndex" mode="horizontal" router @select="handleSelect">
            <el-menu-item index="/homePage">首页</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
            <el-menu-item index="/Amazon">亚马逊服务政策</el-menu-item>
          </el-menu>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: "rowheader",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: "/homepage",
    };
  },
  activated() {
    this.$router.push("/homePage");
    this.activeIndex = "/homePage"
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    }
  }
};
</script>
<style scoped>
header {
  background: #fff;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.05); */
  color: #0000;
  font-size: 18px;
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  border-bottom: 1px solid rgba(190, 191, 195, 1);
}

.h80 {
  height: 60px !important;
}

header .nav-main-box .container {
  display: flex;
  align-items: center;
  height: inherit;
}

.container {
  width: 80%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

header .nav-main-box .company-logo {
  height: inherit;
  margin-right: 50px;
  padding: 10px 0;
  display: flex;
  width: 100%;
}

header .nav-main-box .nav-box {
  display: flex;
  width: 260px;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  align-content: center;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul:after {
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
  content: ".";
}

header .nav-main-box .nav-box li {
  position: relative;
  height: 100%;
  line-height: 60px;
}

li {
  list-style: none;
}

header .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: solid 4px #2987FA !important;
}

header .nav-main-box .nav-box li a.active {
  border-bottom: solid 4px #2987FA;
  height: 100%;
}

header .nav-main-box .el-menu li {
  color: #19242f;
  display: inline-block;
  font-size: 18px !important;
  font-weight: 400 !important;
  padding: 0px !important;
  margin: 0px 40px;
}
</style>